import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Dialog, DialogTitle, DialogContent, Grid, DialogActions, Typography, Button } from '@mui/material';

const NavigationStepValidationComponent = ({ t, showModal, message, onHandleShowModal }) => {
  const closeModal = () => {
    onHandleShowModal(false);
  };

  return (
    <Dialog open={showModal} aria-labelledby='reports-dialog-title' maxWidth={'lg'}>
      <DialogTitle id='reports-dialog-title'>{t('OfferAction.MessageNavigationStep')}</DialogTitle>
      <DialogContent>
        <Grid container>
          <Typography>{message}</Typography>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeModal} color='primary' variant='outlined'>
          {t('Close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

NavigationStepValidationComponent.propTypes = {
  t: PropTypes.func.isRequired,
  message: PropTypes.string,
  showModal: PropTypes.bool.isRequired,
  onHandleShowModal: PropTypes.func.isRequired
};

export default withTranslation()(NavigationStepValidationComponent);
